
import React from 'react';

export const BackgroundEffects = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
    {/* Animated gradient background */}
    <div className="absolute inset-0 bg-gradient-to-br from-purple-100/30 via-purple-200/20 to-purple-50/10 animate-glass-morph -z-10"></div>
    
    {/* Glass shapes */}
    <div className="glass-shapes -z-10">
      <div 
        className="glass-circle animate-glass-pulse"
        style={{
          top: '10%',
          left: '5%',
          width: '100px',
          height: '100px',
          animationDelay: '0s',
          zIndex: '-1'
        }}
      ></div>
      <div 
        className="glass-square animate-glass-pulse"
        style={{
          top: '30%',
          right: '10%',
          width: '150px',
          height: '150px',
          animationDelay: '1s',
          zIndex: '-1'
        }}
      ></div>
      <div 
        className="glass-circle animate-glass-pulse"
        style={{
          bottom: '20%',
          left: '15%',
          width: '80px',
          height: '80px',
          animationDelay: '2s',
          zIndex: '-1'
        }}
      ></div>
      <div 
        className="glass-circle animate-glass-pulse"
        style={{
          bottom: '15%',
          right: '20%',
          width: '120px',
          height: '120px',
          animationDelay: '1.5s',
          zIndex: '-1'
        }}
      ></div>
    </div>

    {/* Shine effect */}
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-glass-shine -z-10"></div>
  </div>
); 